import { createRouter, createWebHistory } from 'vue-router'
import authService from '@/services/authService'

const routes = [
  // ── Public routes (no auth required) ──────────────────────────────
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginPage.vue'),
    meta: { public: true }
  },
  // ── Authenticated routes ──────────────────────────────────────────
  {
    path: '/visao-geral',
    name: 'visao-geral',
    component: () => import('@/views/OverviewPage.vue')
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: () => import('@/views/ClientesPage.vue')
  },
  {
    path: '/buscador',
    name: 'buscador',
    component: () => import('@/views/BuscadorPage.vue')
  },
  {
    path: '/criar-filtros',
    name: 'criar-filtros',
    component: () => import('@/views/ChatFiltersPage.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/AdminPage.vue')
  },
  {
    path: '/painel-de-controle',
    name: 'painel-de-controle',
    component: () => import('@/views/PainelControlePage.vue')
  },
  // ── Default redirect ────────────────────────────────────────────────
  {
    path: '/',
    redirect: '/buscador'
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/buscador'
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// ── Global navigation guard ──────────────────────────────────────────
router.beforeEach(async (to, from, next) => {
  // 1. Public routes — always allowed
  if (to.meta.public) return next()

  // 2. Check authentication — use recently-verified cache for speed,
  //    otherwise hit the backend to ensure the cookie is still valid.
  let user = authService.getVerifiedCachedUser()
  if (!user) {
    user = await authService.getCurrentUser()
  }

  if (!user) {
    // Not authenticated → redirect to login, remembering where they wanted to go
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  return next()
})

export default router
